import React, { forwardRef } from 'react'
import { SpacerProps } from './Spacer.types'
import Box from '../Box/Box'

const Spacer = forwardRef<HTMLDivElement, SpacerProps>(
  (
    { size = 16, horizontal = false, vertical = false, flex = false, ...props },
    ref
  ) => {
    const getSize = () => {
      if (typeof size === 'number') return `${size}px`
      return size
    }

    const sizeValue = getSize()
    const isHorizontal = horizontal || (!horizontal && !vertical)

    return (
      <Box
        ref={ref}
        width={isHorizontal ? sizeValue : undefined}
        height={vertical ? sizeValue : undefined}
        flex={flex === true ? 1 : flex || undefined}
        flexShrink={flex ? 0 : undefined}
        {...props}
      />
    )
  }
)

Spacer.displayName = 'Spacer'

export default Spacer
